<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">Impara a programmare con C++</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    <span class="underline-p">Arduino è una scheda elettronica</span> dotata di
    un microcontrollore programmabile, in grado di leggere input e trasformarli
    in output. La scheda arduino si programma con C++, un linguaggio orientato
    agli oggetti semplice e intuitivo,
    <span class="underline-a"
      >adatto anche per chi si avvicina per la prima volta</span
    >
    alla programmazione testuale.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/arduino-1.png"
        alt="arduino"
       
        class="arduino-1"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">
    Realizza il tuo circuito elettronico e testalo online.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Con Arduino si possono realizzare, in maniera rapida e semplice,
    <span class="underline-a"> dispositivi elettronici</span> in grado di
    attivare un motore e regolarne la velocità, oppure accendere la luce di un
    led.
  </p>
  <p class="w-500 neutral-100 pt-4 px-2 px-xl-5">
    L’elettronica programmabile con Arduino diventa alla portata di tutti, anche
    senza la disponibilità di un laboratorio di elettronica o dei componenti
    fisici, grazie all’utilizzo di
    <span class="underline-p">Tinkercad Circuits</span>.
  </p>
  <p class="w-500 neutral-100 pt-4 px-2 px-xl-5">
    All’interno del suo ambiente di lavoro, infatti, gli studenti possono
    trovare molteplici componenti virtuali da utilizzare per
    <span class="underline-b">costruire e simulare i propri progetti</span>.
  </p>
</div>

<div class="fifth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/arduino-2.png"
        alt="arduino robot"
       
        class="arduino-2"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
